<template>
  <v-img
    :src="resolvedSrc"
    :aspect-ratio="fillParent ? undefined : aspectRatio"
    :contain="contain"
    :height="fillParent ? '100%' : height"
    :width="fillParent ? '100%' : width"
    loading="lazy"
    class="scan-product-image grey lighten-5"
    :class="{
      'rounded-lg': rounded,
      'scan-product-image--fill': fillParent,
    }"
    @error="onError"
  >
    <template v-slot:placeholder>
      <div class="d-flex fill-height align-center justify-center scan-product-image__ph">
        <v-img
          src="/images/no_food_photo.svg"
          contain
          max-width="45%"
          alt=""
          role="presentation"
        />
      </div>
    </template>
  </v-img>
</template>

<script>
/**
 * QR scan menu product image: lazy load + neutral SVG when missing or broken URL.
 * Avoids showing store logo (pos.png) as a fake product photo.
 */
export default {
  name: "ScanProductImage",
  props: {
    img: { default: null },
    contain: { type: Boolean, default: true },
    aspectRatio: { type: [Number, String], default: 1 },
    height: { type: [String, Number], default: "100%" },
    width: { type: [String, Number], default: "100%" },
    rounded: { type: Boolean, default: false },
    /** Fill a position:relative square media box (menu grid). */
    fillParent: { type: Boolean, default: false },
  },
  data() {
    return {
      failed: false,
    };
  },
  computed: {
    resolvedSrc() {
      if (this.failed) {
        return "/images/no_food_photo.svg";
      }
      const raw = this.img;
      if (raw === null || raw === undefined || raw === "") {
        return "/images/no_food_photo.svg";
      }
      const url = Help.img(raw);
      if (!url) {
        return "/images/no_food_photo.svg";
      }
      return url;
    },
  },
  watch: {
    img() {
      this.failed = false;
    },
  },
  methods: {
    onError() {
      this.failed = true;
    },
  },
};
</script>

<style scoped>
.scan-product-image__ph {
  background: var(--qr-subtle-bg, rgba(40, 28, 16, 0.04));
}

.scan-product-image--fill {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100% !important;
  height: 100% !important;
}
</style>
